// Critical CSS loading utilities
// This helper file configures critical CSS path preloading

import { SUPPORTED_LOCALES } from "@/lib/i18n-locales";

export const CRITICAL_CSS = {
  // Main stylesheet
  main: "",

  // Critical path CSS for key pages
  home: "",
  about: "",
  plans: "",
  demo: "",

  // Components critical CSS
  header: "",
  footer: "",
};

// Critical routes to preload for common navigation paths
export const CRITICAL_ROUTES = [
  "/",
  "/about",
  "/pricing",
  "/demo",
  "/resources",
  "/tools",
  "/support",
  "/cases",
];

// Font preloading configuration
export const FONT_PRELOAD = {
  sans: "",
  mono: "",
};

const normalizeRoutePath = (route: string): string => {
  const [pathOnly] = route.split(/[?#]/);
  const segments = pathOnly.split("/").filter(Boolean);

  if (segments.length === 0) return "/";

  const localeCandidate = segments[0]?.toLowerCase();
  if (
    localeCandidate &&
    (SUPPORTED_LOCALES as readonly string[]).includes(localeCandidate)
  ) {
    const remaining = segments.slice(1);
    return remaining.length > 0 ? `/${remaining.join("/")}` : "/";
  }

  return `/${segments.join("/")}`;
};

// Configure route-based critical resources
export function getCriticalAssets(route: string) {
  const normalizedRoute = normalizeRoutePath(route);

  // Base assets to preload on all pages
  const baseAssets = {
    css: [CRITICAL_CSS.main, CRITICAL_CSS.header, CRITICAL_CSS.footer],
    fonts: [FONT_PRELOAD.sans],
    images: [],
  };

  // Route-specific critical assets
  switch (normalizedRoute) {
    case "/":
      return {
        ...baseAssets,
        css: [...baseAssets.css, CRITICAL_CSS.home],
        images: [...baseAssets.images, "/images/hero-image.png"],
      };
    case "/about":
      return {
        ...baseAssets,
        css: [...baseAssets.css, CRITICAL_CSS.about],
      };
    case "/pricing":
      return {
        ...baseAssets,
        css: [...baseAssets.css, CRITICAL_CSS.plans],
      };
    case "/demo":
      return {
        ...baseAssets,
        css: [...baseAssets.css, CRITICAL_CSS.demo],
      };
    default:
      return baseAssets;
  }
}
